import {configureStore} from "@reduxjs/toolkit";
import {createEpicMiddleware} from "redux-observable";
import * as _ from 'lodash';

import rootReducer from './reducers/rootReducer';
import {rootEpic} from "./reducers/rootEpic";

import {loadStorage, saveStorage} from "./sessionStorage";


const persistedState = loadStorage();
const epicMiddleware = createEpicMiddleware();

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(epicMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
    preloadedState: persistedState
});

export const getStore = () => store;

epicMiddleware.run(rootEpic);

if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./reducers/rootReducer', () => {
        const newRootReducer = require('./reducers/rootReducer').default
        store.replaceReducer(newRootReducer)
    });
}

store.subscribe(_.throttle(() => {
    saveStorage({
        individui: store.getState().individui,
        docenti: store.getState().docenti,
        datiRegistro: store.getState().datiRegistro,
        auth: store.getState().auth,
        pianificazione: store.getState().pianificazione,
        tipiGiustificativi: store.getState().tipiGiustificativi,
        tipoAttivita: store.getState().tipoAttivita,
        profiliOrari: store.getState().profiliOrari,
        datiCastelletto: store.getState().datiCastelletto,
        validazione: store.getState().validazione,
        configurationFile: store.getState().configurationFile
    });
}, 100));

export default store;
